import { createSlice } from "@reduxjs/toolkit";

// Filter state for the State Agency dashboard. Small + persisted (redux-persist)
// so an agency's district/year selection survives a reload.
const initialState = {
  // [] means "all allocated districts". Otherwise a chosen subset of ids.
  selectedDistrictIds: [],
  academicYearId: "", // "" = latest available (resolved from the data)
  // The effective districts ([{value,label}]) handed to the State Audit report
  // so its KPIFilterBar dropdown is limited to the agency's districts.
  auditDistricts: [],
};

export const stateAgencySlice = createSlice({
  name: "stateAgency",
  initialState,
  reducers: {
    setSelectedDistricts(state, action) {
      state.selectedDistrictIds = action.payload || [];
    },
    setStateAgencyYear(state, action) {
      state.academicYearId = action.payload ?? "";
    },
    setAuditDistricts(state, action) {
      state.auditDistricts = action.payload || [];
    },
    resetStateAgency: () => initialState,
  },
});

export const { setSelectedDistricts, setStateAgencyYear, setAuditDistricts, resetStateAgency } =
  stateAgencySlice.actions;

export default stateAgencySlice.reducer;
